import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="inline-edit"
export default class extends Controller {
  // Target Defs::
  // selectBox: the select box which replaces the field
  // option: every option in the select box
  // button: the select box element without options.
  // dropdown: options dropdown
  // selected: the selected element which is displayed in the button.
  // form: the form to submit after an option is selected.
  // hidden: the hidden field to update when an option is selected.
  // house: The main container of the elements.
  static targets = ["option", "button", "dropdown", "selected", "form", "hidden", "house"];

  reveal(event) {
    this.expand();
  }

  submit(event) {
    event.preventDefault(); // Prevent the default form submission behavior.

    this.shrink();
    const value = event.target.textContent.trim();
    const form = this.formTarget;
    this.hiddenTarget.value = value;

    fetch(form.action, {
      method: form.method,
      body: new FormData(form),
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-Requested-With': 'XMLHttpRequest'
      },
    })
      .then(response => {
        if (response.ok) {
          return response.text();
        }
      })
      .then(turboStreamHtml => {
        if (turboStreamHtml) {
          Turbo.renderStreamMessage(turboStreamHtml);
        }
        this.selectedTarget.innerHTML = value;
        this.shrink();
        this.houseTarget.setAttribute('data-current-value', value);
        this.houseTarget.dispatchEvent(new Event('change'));
      })
  }

  expand() {
    const dropdown = this.dropdownTarget;
    dropdown.classList.remove("opacity-0", "hidden");
    dropdown.classList.add("opacity-100", "block");
    this.buttonTarget.setAttribute("aria-expanded", true);
  }

  shrink() {
    this.buttonTarget.setAttribute("aria-expanded", false);
    this.dropdownTarget.classList.remove("opacity-100", "block");
    this.dropdownTarget.classList.add("opacity-0", "hidden");
  }

  toggle(event) {
    if (this.dropdownTarget.classList.contains("hidden")) {
      this.expand();
    } else {
      this.shrink();
    }
  }
}
